<template>
    <el-button
        :loading="csvIsLoading"
        type="primary"
        plain
        @click="downloadCsv"
    >
        {{ getTextButton }}
    </el-button>
</template>

<script>
import moment from 'moment';
export default {

    components: {

    },

    props: {
        url: {
            type: [String, Function],
            required: true,
        },
        modelName: {
            type: String,
            required: true,
        },
        textButton: {
            type: String,
            default: undefined,
        },
        scoped: {
            type: Boolean,
            required: true
        },
    },

    data: function(){
        return {
            csvIsLoading: false,
        };
    },

    computed: {
        getTextButton() {
            return this.textButton || this.$store.getters['fundation/getVerbose']('ns_paginate_csv_button');
        }
    },

    mounted: function(){

    },

    methods: {
        downloadCsv (){
            let url = typeof this.url === 'string' ? this.url : this.url();
            url = url.split('?');
            url.splice(1, 0, 'export/?');
            url = url.join('');

            const scopes = (this.scoped) ? this.$store.state.api.scopes : {};
            const config = {
                headers: scopes
            };

            this.csvIsLoading = true;
            this.$store.axios.get(`${url}`, config).then((response) => {
                this.csvIsLoading = false;
                let blob = new Blob(["\ufeff", response.data]);
                let url = URL.createObjectURL(blob);

                let link = document.createElement("a");
                link.style = 'display: none';
                link.href = url;
                link.download = `export-${moment().format('YYYY-MM-DD-HH-mm')}-${this.modelName}.csv`;
                document.body.appendChild(link); // Required for FF
                link.click(); // This will download the data file named "my_data.csv".
            }).catch((e) => {
                this.csvIsLoading = false;
            });
        },
    },
};
</script>

<style lang="scss" module>

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/nsPaginate/download-csv-button.vue